// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var List                    = require("bs-platform/lib/js/list.js");
var $$Array                 = require("bs-platform/lib/js/array.js");
var Js_exn                  = require("bs-platform/lib/js/js_exn.js");
var Random                  = require("bs-platform/lib/js/random.js");
var CellData                = require("./cellData");
var Caml_array              = require("bs-platform/lib/js/caml_array.js");
var Caml_builtin_exceptions = require("bs-platform/lib/js/caml_builtin_exceptions.js");

function generateBoard(size) {
  return $$Array.to_list(Caml_array.caml_make_vect(size, $$Array.to_list(Caml_array.caml_make_vect(size, CellData.make(/* None */0, /* Some */[size], /* None */0, /* None */0, /* () */0)))));
}

function generateRandomBoard(size) {
  Random.init(Date.now() | 0);
  var board = Caml_array.caml_make_vect(size, /* [] */0);
  for(var rowIndex = 0 ,rowIndex_finish = size - 1 | 0; rowIndex <= rowIndex_finish; ++rowIndex){
    var currRow = Caml_array.caml_make_vect(size, CellData.make(/* None */0, /* Some */[size], /* None */0, /* None */0, /* () */0));
    for(var cellIndex = 0 ,cellIndex_finish = size - 1 | 0; cellIndex <= cellIndex_finish; ++cellIndex){
      if (Random.$$int(3)) {
        Caml_array.caml_array_set(currRow, cellIndex, CellData.make(/* Some */[0], /* Some */[size], /* Some */[rowIndex], /* Some */[cellIndex], /* () */0));
      } else {
        Caml_array.caml_array_set(currRow, cellIndex, CellData.make(/* Some */[1], /* Some */[size], /* Some */[rowIndex], /* Some */[cellIndex], /* () */0));
      }
    }
    Caml_array.caml_array_set(board, rowIndex, $$Array.to_list(currRow));
  }
  return $$Array.to_list(board);
}

function generate(size, genType) {
  if (genType !== 0) {
    return generateRandomBoard(size);
  } else {
    return generateBoard(size);
  }
}

function toggleCell(currBoard, x, y) {
  var size = List.length(currBoard);
  return List.mapi((function (rowIndex, row) {
                return List.mapi((function (cellIndex, cell) {
                              var match = cell[/* value */0];
                              var match$1 = +(rowIndex === x && cellIndex === y);
                              if (match !== 0) {
                                if (match !== 1 || match$1 === 0) {
                                  return cell;
                                } else {
                                  return CellData.make(/* Some */[0], /* Some */[size], /* Some */[rowIndex], /* Some */[cellIndex], /* () */0);
                                }
                              } else if (match$1 !== 0) {
                                return CellData.make(/* Some */[1], /* Some */[size], /* Some */[rowIndex], /* Some */[cellIndex], /* () */0);
                              } else {
                                return cell;
                              }
                            }), row);
              }), currBoard);
}

function neighborValue(board, rowIndex, cellIndex) {
  var exit = 0;
  var cellData;
  try {
    cellData = List.nth(List.nth(board, rowIndex), cellIndex);
    exit = 1;
  }
  catch (raw_exn){
    var exn = Js_exn.internalToOCamlException(raw_exn);
    var exit$1 = 0;
    if (exn[0] === Caml_builtin_exceptions.invalid_argument) {
      if (exn[1] === "List.nth") {
        return 0;
      } else {
        exit$1 = 2;
      }
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      if (exn[0] === Caml_builtin_exceptions.failure) {
        if (exn[1] === "nth") {
          return 0;
        } else {
          throw exn;
        }
      } else {
        throw exn;
      }
    }
    
  }
  if (exit === 1) {
    return cellData[/* value */0];
  }
  
}

function tick(currBoard) {
  var size = List.length(currBoard);
  var board = Caml_array.caml_make_vect(size, /* [] */0);
  for(var rowIndex = 0 ,rowIndex_finish = size - 1 | 0; rowIndex <= rowIndex_finish; ++rowIndex){
    var currRow = Caml_array.caml_make_vect(size, CellData.make(/* None */0, /* Some */[size], /* None */0, /* None */0, /* () */0));
    for(var cellIndex = 0 ,cellIndex_finish = size - 1 | 0; cellIndex <= cellIndex_finish; ++cellIndex){
      var n0 = neighborValue(currBoard, rowIndex - 1 | 0, cellIndex - 1 | 0);
      var n1 = neighborValue(currBoard, rowIndex - 1 | 0, cellIndex);
      var n2 = neighborValue(currBoard, rowIndex - 1 | 0, cellIndex + 1 | 0);
      var n3 = neighborValue(currBoard, rowIndex, cellIndex - 1 | 0);
      var n4 = neighborValue(currBoard, rowIndex, cellIndex + 1 | 0);
      var n5 = neighborValue(currBoard, rowIndex + 1 | 0, cellIndex - 1 | 0);
      var n6 = neighborValue(currBoard, rowIndex + 1 | 0, cellIndex);
      var n7 = neighborValue(currBoard, rowIndex + 1 | 0, cellIndex + 1 | 0);
      var liveNeighborCount = ((((((n0 + n1 | 0) + n2 | 0) + n3 | 0) + n4 | 0) + n5 | 0) + n6 | 0) + n7 | 0;
      var currCellData = List.nth(List.nth(currBoard, rowIndex), cellIndex);
      var match = currCellData[/* value */0];
      var status = match !== 0 ? (
          match !== 1 ? currCellData[/* value */0] : (
              liveNeighborCount >= 2 && liveNeighborCount < 4 ? 1 : 0
            )
        ) : (
          liveNeighborCount !== 3 ? currCellData[/* value */0] : 1
        );
      Caml_array.caml_array_set(currRow, cellIndex, CellData.make(/* Some */[status], /* Some */[size], /* Some */[rowIndex], /* Some */[cellIndex], /* () */0));
    }
    Caml_array.caml_array_set(board, rowIndex, $$Array.to_list(currRow));
  }
  return $$Array.to_list(board);
}

exports.generateBoard       = generateBoard;
exports.generateRandomBoard = generateRandomBoard;
exports.generate            = generate;
exports.toggleCell          = toggleCell;
exports.neighborValue       = neighborValue;
exports.tick                = tick;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/board.re
// module id = 43
// module chunks = 0